import { Component, Input, Output, EventEmitter } from '@angular/core'
import { VARIANTS } from 'src/lib/constants'

@Component({
  selector: 'maglive-variant-modal',
  templateUrl: './variant-modal.component.html',
  styleUrls: ['./variant-modal.component.scss'],
})
export class VariantModalComponent {
  @Input() selectedVariant
  @Output() changeVariantEvent = new EventEmitter<string>()
  @Output() toggleVariantModalEvent = new EventEmitter<void>()

  variants = VARIANTS

  changeVariant(variant): void {
    this.changeVariantEvent.emit(variant)
  }

  toggleVariantModal(): void {
    this.toggleVariantModalEvent.emit()
  }
}